import {useUserContext, useWatchListings, useWatchMessageRule} from "@hosttools/frontend";
import {useEffect, useMemo, useState} from "react";

import type {QuickGuide} from "./type";

const TOTAL_STEPS = 5;

function useQuickGuide(): {
    quickGuide: QuickGuide | undefined;
    numberCompleted: number | undefined;
    totalSteps: number;
    isAllStepCompleted: boolean;
} {
    const {accounts} = useUserContext();
    const {messageRules} = useWatchMessageRule({});
    const {listings} = useWatchListings();

    const [quickGuide, setQuickGuide] = useState<QuickGuide>();

    const numberCompleted = useMemo(
        () =>
            quickGuide
                ? Object.keys(quickGuide).filter(key => quickGuide?.[key]).length + 1
                : undefined,
        [quickGuide]
    );

    useEffect(() => {
        if (listings && accounts && messageRules) {
            setQuickGuide(prev => ({
                ...prev,
                ...listings.reduce<QuickGuide>((result, listing) => {
                    if (listing.basePrice && listing.minPrice && listing.priceSource) {
                        result.configPricing = true;
                    }
                    if (listing.listingEnabled) {
                        result.enableListing = true;
                    }
                    return result;
                }, {}),
                connectAccount: !!accounts.find(account => !!account.lastLoginAttemptSuccessful),
                enableMessageRule: !!messageRules.find(messageRule => !messageRule.paused)
            }));
        }
    }, [listings, messageRules, accounts]);

    return useMemo(
        () => ({
            quickGuide,
            numberCompleted,
            isAllStepCompleted: numberCompleted === TOTAL_STEPS,
            totalSteps: TOTAL_STEPS
        }),
        [numberCompleted, quickGuide]
    );
}

export default useQuickGuide;
